import { useGetAssociation } from 'legacy/groups/hooks';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AssociatedWithSkeleton from './components/AssociatedWithSkeleton';

const AssociatedWith = ({
  associationId,
}: {
  associationId: string;
}) => {
  const { t } = useTranslation(['organizations']);
  const { data: association, isLoading, isError } = useGetAssociation({ associationId });

  // Hide component if loading failed or no association data
  if (isError || (!isLoading && !association)) {
    return null;
  }

  // Show skeleton while loading
  if (isLoading) {
    return <AssociatedWithSkeleton />;
  }

  return (
    <div className="flex flex-col gap-2 md:mt-3 mb-6">
      <p className="text-[#575757]">{t('associatedWith.label')}</p>
      <Link
        href={`/associations/${associationId}`}
      >
        <div className="flex flex-row gap-2 items-center hover:underline underline-offset-2 decoration-2">
          <div 
            className="bg-cover w-[40px] rounded-lg overflow-hidden" 
            style={{
              boxShadow: '0 4px 15px 0 rgba(99, 134, 254, 0.10), 0 15px 30px 0 rgba(99, 134, 254, 0.08)'
            }}
          >
            <img src={association.logoImage} alt={`${association.name}'s badge`} />
          </div>
          <p className="text-lg font-bold text-left">{association.name}</p>
        </div>
      </Link>
    </div>
  );
};

export default AssociatedWith;
